import { signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "../firebase";

// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    console.log("User Info:", result.user); // Use user info as needed
    return result.user;
  } catch (error) {
    console.error("Error signing in:", error.message);
  }
};

// Sign out
export const logout = async () => {
  try {
    await signOut(auth);
    console.log("User signed out");
  } catch (error) {
    console.error("Error signing out:", error.message);
  }
};
